import { Card as AntCard, CardProps } from "antd";
import cn from 'classnames';
interface CardInterface extends CardProps {
  headerBorder?: boolean;
}
export const Card = ({
  headerBorder,
  children,
  className,
  ...rest
}: CardInterface) => {
  return <>
            <AntCard className={cn(className, {
      ['headerBorder']: headerBorder
    })} {...rest} data-sentry-element="AntCard" data-sentry-source-file="index.tsx">
                {children}
            </AntCard>
        </>;
};